export default __webpack_public_path__ + "static/media/Migration-NIC-Protal.412b7a25.jpeg";